import * as React from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

export default function NovaPoshtaDialog({ open, items, onClose }) {
	console.log("items", items);
	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 400,
		bgcolor: "background.paper",
		border: "2px solid #000",
		boxShadow: 24,
		p: 4,
	};

	if (!items || !items.length) return <></>;
	return (
		<Modal open={open} aria-labelledby="modal-title" onClose={onClose}>
			<Box sx={style}>
				{items.map((item) => (
					<Box>
						{item.code} - {item.status}
					</Box>
				))}
			</Box>
		</Modal>
	);
}
